import {put, takeLatest} from 'redux-saga/effects';
import {FORMS_FETCH_CONFIGS} from './constants';
import {appLoadInitValues} from '../app/actions';

export function* formsFetchConfigsSaga() {
	yield takeLatest(FORMS_FETCH_CONFIGS, function* () {
		yield put(appLoadInitValues());
	});
}
